import React from 'react';

import styles from './DrawerExtension.scss';

type Props = {
  children: React.ReactNode;
};

function DrawerExtension(props: Props) {
  return <div className={styles.container}>{props.children}</div>;
}

export default React.memo(DrawerExtension);
